import React, { useEffect, useState, PureComponent } from 'react';
import { useForm } from "react-hook-form";

import { SketchPicker } from 'react-color';

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import { ReactComponent as Remove } from '../assets/remove.svg';


export default function Icon ({icon, saveIcon, hideIcon, index}) {

    const imageMimeType = /image\/(png|gif|jpg|jpeg|webp|svg\+xml)/i;
    //const [image, setImage] = useState(icon);
    //const [filename, setFilename] = useState();
    const [fileError, setFileError] = useState('');
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const remove = event => {
        //setFilename(false);
        //setSelectedFile(false);
        saveIcon (false);
        //setImage(false)
    }

    const clearFile = event => {
        event.target.value = '';
    }

    const changeFile = event => {

        setFileError('');

        // preview image

//         if (!event.target.files || event.target.files.length === 0) {
//             setSelectedFile(false)
//             return
//         }
        var file = event.target.files[0];
        //setFilename(file.name);
        //setSelectedFile(file);

        // save

         if (file === 'undefined'){
            setFileError ("Not valid image");
            return;
        }

        if (!imageMimeType.test(file.type)) {
            setFileError ("Image type is not valid");
            return;
        }

        console.log(file);
        saveIcon (file, index);
    };

    // preview image

//     const [selectedFile, setSelectedFile] = useState();
//     useEffect(() => {
//         if (!selectedFile) {
//             //setImage(undefined)
//             return
//         }
//
//         const objectUrl = URL.createObjectURL(selectedFile)
//         if (objectUrl)
//             setImage(objectUrl);
//
//         return () => URL.revokeObjectURL(objectUrl)
//     }, [selectedFile])
//
//


    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };



    return (

        <div className="activity-icon">

            <div className="">

                <div className="flex">

                    <label>
                        <input
                            type="file"
                            placeholder={"Url"}
                            onChange={changeFile}
                            onClick={clearFile}
                        />
                        <div className="button">Select File</div>
                    </label>

                    {/*{filename}*/}

                    <div className="error">{fileError}</div>


                    <div className="error">{ message }</div>

                    <div className="download-icon">
                        <div className="icon">
                            {icon ?
                                <img src={icon} alt="" />
                                :
                                null
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )

}
